import * as Sentry from '@sentry/nextjs';

if (process.env.NEXT_PUBLIC_MODE === 'production') {
    Sentry.init({
        dsn: 'https://b2fdf7aece7818d3b2bf96b3cc43b0fe@o385711.ingest.us.sentry.io/4505587874660352',

        // Adds request headers and IP for users, for more info visit:
        // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
        sendDefaultPii: true,
        environment: process.env.NEXT_PUBLIC_MODE,
        debug: false,
        maxValueLength: 1048576,

        // Capture Replay for 10% of all sessions,
        // plus for 100% of sessions with an error
        // Learn more at
        // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,

        // Note: if you want to override the automatic release value, do not set a
        // `release` value here - use the environment variable `SENTRY_RELEASE`, so
        // that it will also get attached to your source maps
    });
}

// This export will instrument router navigations, and is only relevant if you enable tracing.
// `captureRouterTransitionStart` is available from SDK version 9.12.0 onwards
export const onRouterTransitionStart =
    process.env.NEXT_PUBLIC_MODE === 'production'
        ? Sentry.captureRouterTransitionStart
        : () => {};
